/**
 * Measured geometry of Form 2848 (Rev. January 2021), extracted from a 288dpi
 * render of public/reference/f2848-irs.pdf. Units are PDF points, y from the
 * top of the page. US Letter, 612 x 792pt.
 *
 * GENERATED — do not hand-edit. Re-derive if the form revision changes.
 *
 * Source note: the copy originally supplied (public/reference/f2848.pdf) is
 * the same form and revision, but flattened to vector outlines with no text
 * layer and printed onto A4 — it is exactly this Letter artwork scaled 0.9743
 * and shifted down 35.9pt. The replica is built at the Letter geometry below,
 * matching the W-7 and SS-4 replicas.
 *
 * The form mixes solid rules with dashed write-in rules (CAF No., PTIN,
 * Telephone/Fax, the signature lines). Dashed rules must be drawn as
 * individual dashes: html2canvas renders neither border-style nor gradients.
 */

/** Page 1 solid rules: [y, x0, x1] */
/* The two rules that boxed the IRS web-fillable "Check Form for Common
 * Errors & Reminders" link have been dropped — that box is not part of the
 * printed form and is absent from the supplied copy. */
export const H_SOLID_P1: readonly (readonly number[])[] = [
  [48, 489.0, 576.0],
  [84, 36.0, 490.0],
  [84, 518.2, 576.0],
  [96, 532.5, 576.0],
  [108, 525.2, 576.0],
  [120, 36.0, 576.0],
  [132, 36.0, 576.0],
  [156, 338.2, 576.0],
  [180, 36.0, 576.0],
  [204, 36.0, 576.0],
  [264, 36.0, 576.0],
  [324, 36.0, 576.0],
  [384, 36.0, 576.0],
  [444, 36.0, 576.0],
  [504, 36.0, 576.0],
  [540, 36.0, 576.0],
  [564, 36.0, 576.0],
  [588, 36.0, 576.0],
  [612, 36.0, 576.0],
  [636, 36.0, 576.0],
  [672, 446.2, 576.0],
  [684, 64.5, 576.0],
  [696, 64.5, 576.0],
  [720, 158.2, 576.0],
  [732, 64.5, 576.0],
  [744, 36.0, 576.0],
];

/** Page 1 dashed write-in rules: [y, x0, x1] */
export const H_DASHED_P1: readonly (readonly number[])[] = [
  [216, 388.5, 533.0],
  [228, 377.8, 532.8],
  [240, 413.2, 532.2],
  [252, 388.8, 533.0],
  [276, 388.5, 533.0],
  [288, 377.8, 532.8],
  [300, 413.2, 532.2],
  [312, 388.8, 533.0],
  [336, 388.5, 533.0],
  [348, 377.8, 532.8],
  [360, 412.8, 533.0],
  [372, 388.8, 533.0],
  [396, 388.5, 533.0],
  [408, 377.8, 532.8],
  [420, 412.8, 533.0],
  [432, 389.2, 532.2],
];

/** Page 1 vertical rules: [x, y0, y1] */
export const V_RULES_P1: readonly (readonly number[])[] = [
  [122.0, 36, 85],
  [302.2, 204, 444],
  [302.2, 504, 612],
  [338.2, 132, 180],
  [446.2, 504, 612],
  [460.5, 156, 180],
  [489.0, 36, 120],
];

/** Page 2 solid rules: [y, x0, x1] */
export const H_SOLID_P2: readonly (readonly number[])[] = [
  [48, 36.0, 576.0],
  [156, 36.0, 576.0],
  [288, 36.0, 576.0],
  [300, 36.0, 576.0],
  [576, 36.0, 576.0],
  [624, 36.0, 576.0],
  [648, 36.0, 576.0],
  [672, 36.0, 576.0],
  [696, 36.0, 576.0],
  [720, 36.0, 576.0],
];

/** Page 2 dashed write-in rules: [y, x0, x1] */
export const H_DASHED_P2: readonly (readonly number[])[] = [
  [96, 488.8, 576.0],
  [108, 64.5, 576.0],
  [240, 36.0, 259.5],
  [240, 273.2, 345.8],
  [240, 359.8, 576.0],
  [276, 36.0, 259.5],
  [276, 273.2, 575.2],
];

/** Page 2 vertical rules: [x, y0, y1] */
export const V_RULES_P2: readonly (readonly number[])[] = [
  [100.5, 576, 721],
  [179.8, 576, 721],
  [295.0, 576, 721],
  [518.2, 576, 721],
];

/** Dashed rules run a 2pt dash on a 3pt pitch. */
export const DASH_LEN = 2;
export const DASH_PITCH = 3;

/*
 * Checkbox positions are NOT exported. The detector found 25 boxes on page 1
 * and 4 on page 2 against roughly 20 and 1 real ones — it also matched the ▶
 * markers and some glyph counters. The pages place each <Cb> at its measured
 * coordinate instead, so this data would only mislead.
 */
